__turbopack_context__.v({
  "bannerContainer": "Tags-module__p5Poya__bannerContainer",
  "bannerContainerContent": "Tags-module__p5Poya__bannerContainerContent",
  "bannerContainerImage": "Tags-module__p5Poya__bannerContainerImage",
  "postCardContainer": "Tags-module__p5Poya__postCardContainer",
  "read_more_button": "Tags-module__p5Poya__read_more_button",
});
